<template>
  <div class="root">
    <Banner :loading="loading">
      <div class="content-wrapper">
        <slot v-if="!loading" name="image" />
        <div class="content">
          <p v-if="!loading && title" class="content-title">
            {{ title }} <span style="font-size: 12px; color: gray">{{ subtitle ? '(' + subtitle + ')' : '' }}</span>
          </p>
          <p v-if="!loading && description" class="description" :class="{ signal: signalColor, [signalColor]: signalColor }">
            {{ description }}
          </p>
        </div>
      </div>
      <div v-if="!loading" class="actions">
        <slot name="actions" />
      </div>
    </Banner>
  </div>
</template>

<script>
import Banner from '@/components/base/banner'

export default {
  name: 'BannerStatus',
  components: { Banner },
  props: {
    title: { type: String, required: false, default: '' },
    subtitle: { type: String, required: false, default: undefined },
    signalColor: { type: String, required: false, default: '' },
    description: { type: String, required: false, default: '' },
    loading: { type: Boolean, required: false, default: false },
    variant: { type: String, required: false, default: 'normal' }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.root {
  min-width: 100%;

  .banner {
    align-items: center;
    justify-content: last flex-end;
    display: flex;
    justify-content: space-between;
    grid-column-gap: 24px;
    grid-template-rows: 1fr 1fr;
    align-items: baseline;

    column-gap: $scale600;

    .content-wrapper {
      display: inline-flex;
      gap: $scale600;
      min-height: 44px;
    }

    .content {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      height: 45px;

      .content-title {
        @include ParagraphMedium;
        font-family: $monserratFontFamily;
        font-weight: 700;
        color: $neutral500;
      }

      .subtitle {
        @include ParagraphMedium;
        font-family: $monserratFontFamily;
        font-weight: 500;
        color: $neutral500;
      }

      .description {
        @include LabelXSmall;
        font-family: $monserratFontFamily;
        font-weight: 700;
        text-transform: uppercase;
        color: $neutral400;

        &.signal {
          &::before {
            content: ' ';
            height: 8px;
            width: 8px;
            margin-right: 8px;
            border-radius: 50%;
            display: inline-block;
          }
          &.color-green {
            &::before {
              background: $positive300;
            }
          }

          &.color-yellow {
            &::before {
              background: $warning300;
            }
          }

          &.color-red {
            &::before {
              background: $negative300;
            }
          }
        }
      }
    }

    .actions {
      display: flex;
      gap: 4px;
      flex-direction: column;
      width: fit-content;
      color: $neutral500;
      align-self: flex-start;
      justify-self: end;
    }
  }
}
</style>
